import {logger} from '@vio/core/src/utils/logging/logger'

import type {
  FetchHopperAdParams,
  HopperAd,
  HopperEventsRequest,
  HopperEventType
} from '../types'

interface HopperAdResponse {
  ads: HopperAd[]
}

interface FireHopperEventParams {
  eventType: HopperEventType
  token: string
}

/**
 * Fetches ads from the HTS display ads API.
 */
export const fetchHopperAd = async (
  params: FetchHopperAdParams
): Promise<HopperAdResponse | null> => {
  try {
    const response = await fetch('/api/hopper/fetch-ad', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(params)
    })

    if (!response.ok) {
      logger.warn(`HTS API returned ${response.status}: ${response.statusText}`)
      return null
    }

    const responseData =
      (await response.json()) as Partial<HopperAdResponse> | null

    if (!responseData || !Array.isArray(responseData.ads)) {
      logger.warn('HTS API returned malformed response')
      return null
    }

    return {ads: responseData.ads}
  } catch (error) {
    logger.warn('Failed to fetch Hopper ad:', error)
    return null
  }
}

/**
 * Fires an event (impression or click) to the HTS events API.
 */
export const fireHopperEvent = async ({
  eventType,
  token
}: FireHopperEventParams): Promise<void> => {
  const body: HopperEventsRequest = {
    events: [{eventType, trackingData: {token}}]
  }

  try {
    await fetch('/api/hopper/events', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    })
  } catch (error) {
    logger.warn(`Failed to fire Hopper ${eventType} event:`, error)
  }
}
